import { styled } from 'styled-components';
import { APP_BAR_NOTIFICATION_OFFSET } from '../../../constants.js';
import { Media } from '../../../theme/Media.js';
export const Wrapper = styled.div `
  top: ${APP_BAR_NOTIFICATION_OFFSET};
  height: calc(100vh - ${APP_BAR_NOTIFICATION_OFFSET});
  z-index: 10;
  transition: transform 0.3s;
  @media ${Media.lgMin} {
    position: sticky;
  }
  @media ${Media.mdMax} {
    position: fixed;
    left: 0;
    transform: translateX(${({ $isCollapsedNav }) => ($isCollapsedNav ? '-100%' : 0)});
  }
  @media ${Media.xsMax} {
    width: 100vw;
  }
`;
